const htmlContainer = document.getElementsByTagName('html')[0];
const lightbox = document.querySelectorAll('.modal');

const lightboxEnable = (lightbox) => {
    lightbox.classList.add('is-active');
    lightbox.querySelector('.modal-background').addEventListener('click', lightboxDisableCall);
    htmlContainer.classList.add('is-clipped');
}

const lightboxDisable = (lightbox) => {
    lightbox.classList.remove('is-active');
    lightbox.querySelector('.modal-background').removeEventListener('click', lightboxDisableCall);
    htmlContainer.classList.remove('is-clipped');
}

const lightboxDisableCall = (e) => lightboxDisable(e.target.parentNode);

// team video lightbox
if (document.body.classList.contains('about_us')) {
    const team = document.getElementById('team');
    const memberPlayBtn = team.querySelectorAll('.memberPlay');

    memberPlayBtn.forEach(btn => {
        btn.addEventListener('click', e => {
            const memberId = btn.closest('.member').dataset.memberId;
            const lightbox = team.querySelector('.modal[data-member-id="' + memberId + '"]');
            lightboxEnable(lightbox);
        });
    });
}

// login lightbox
const loginBtn = document.getElementsByClassName('login');
const lightboxLogin = document.getElementById('lightbox-login');
loginBtn.forEach(login => {
    login.addEventListener('click', e => {
        e.preventDefault();
        lightboxEnable(lightboxLogin);
    });
});

